import { useState } from "react";
import { requestOtp } from "../../Apis/changePasswordApis";
import { setAlert } from "../../redux/alertSlice";
import { useDispatch } from "react-redux";

const useChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [isResetOpen, setIsResetOpen] = useState(false);
  const dispatch = useDispatch();

  const handleChangePassword = async (email) => {
    if (!email) return;

    setLoading(true);
    try {
      const response = await requestOtp(email);
      localStorage.setItem("mealEmpId", response?.data[0]?.empId);
      setIsResetOpen(true);
      dispatch(
        setAlert({
          message: "Otp sent to your registered email address.",
          severity: "success",
        })
      );
    } catch (error) {
      dispatch(
        setAlert({
          message: error.message || "An error occurred. Please try again.",
          severity: "error",
        })
      );
      console.error("Error changing password:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    isResetOpen,
    setIsResetOpen,
    handleChangePassword,
  };
};

export default useChangePassword;
